/** Local reading progress for student iBooks (device-only, no PII). */

const PREFIX = 'ibook-student-progress-';

export interface IbookReadingProgress {
  page: number;
  updatedAt: number;
}

export function progressStorageKey(bookId: string): string {
  return `${PREFIX}${bookId}`;
}

export function readIbookProgress(bookId: string): IbookReadingProgress | null {
  try {
    const raw = localStorage.getItem(progressStorageKey(bookId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as IbookReadingProgress;
    if (typeof parsed.page !== 'number') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function progressPercent(bookId: string, pageCount: number): number {
  if (pageCount <= 0) return 0;
  const saved = readIbookProgress(bookId);
  if (!saved) return 0;
  return Math.min(100, Math.round(((saved.page + 1) / pageCount) * 100));
}

export function progressActionLabel(bookId: string, pageCount: number): 'Continue Reading' | 'Open Book' {
  const saved = readIbookProgress(bookId);
  if (!saved || pageCount <= 0) return 'Open Book';
  if (saved.page > 0) return 'Continue Reading';
  return 'Open Book';
}

export function findMostRecentlyOpenedBook<T extends { book_id: string }>(books: T[]): T | null {
  let best: { book: T; updatedAt: number } | null = null;
  for (const book of books) {
    const saved = readIbookProgress(book.book_id);
    if (!saved) continue;
    if (!best || saved.updatedAt > best.updatedAt) {
      best = { book, updatedAt: saved.updatedAt };
    }
  }
  return best?.book ?? null;
}
